import Vue from 'vue'
import Vuex from 'vuex'

import auth from "./modules/auth"
import orders from "./modules/orders"
import earnings from "./modules/earnings"
import searches from "./modules/searches"
import properties from "./modules/properties"
import statistics from "./modules/statistics"

Vue.use(Vuex)

let state = {
  loader: false
}

export default function (config) {
  return new Vuex.Store({
    namespaced: true,
    state: Object.assign({}, state, config),
    mutations: {
      ['loader'](state, flag) {
        state.loader = flag;
      },
    },
    modules: {
      auth,
      orders,
      earnings,
      searches,
      properties,
      statistics
    }
  })
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/index.js